export const COMMON_ENDPOINTS = {
  offers: "/api/Common/GetOffers",
  deals: "/api/Common/GetDeals",
  dealsModuleData: "/api/Common/GetDealsModuleData",
  reviews: "/api/Common/GetReviews",
  reviewsList: "/api/Common/GetReviewsList",
  saveReview: "/api/Common/SaveReview",
  getCart: "/api/Common/GetCart",
  createCart: "/api/Common/CreateCart",
  removeCart: "/api/Common/RemoveCart",
  banners: "/api/Common/GetBanners",
  newsletter: "/api/Common/SubscribeNewsletter",
  verifyPan: "/api/Common/VerifyPan",
  verifyGst: "/api/Common/GetGSTDetails",
  CreateBooking: "/api/Common/CreateBooking",
  CountryList: "/api/Common/GetCountryList",
  IndiaStateList: "/api/Common/GetIndiaState",
  statesByCountryId: "/api/Common/GetStatesByCountryId",
  GetUserPersonalDetails: "/api/Common/GetUserPersonalDetails",
  PostOrUpdateUserPersonalDetails:
    "/api/Common/PostOrUpdateUserPersonalDetails",
  bookingPageCoupons: "/api/Coupon/GetBookingPageCouponsList",
  couponList: "/api/Coupon/GetCouponList",
  couponCategoryList: "/api/Coupon/GetCouponCategoryList",
  couponModuleList: "/api/Coupon/GetCouponMouleList",
  couponDetail: "/api/Coupon/GetCouponDetail",
  couponHomePageHeading: "/api/Coupon/GetHomePageHeading",
  VerifyCoupon: "/api/Coupon/VerifyCoupon",
  seasonalDeals: "/api/Common/GetSeasonalDeals",
  seasonalDealsData: "/api/Common/GetSeasonalDealsData",
  submitEnquiryForm: "/api/Common/SubmitEnquiryForm",
  missionStatement: "/api/Common/getMissionStatment",
  submitContactUs: "/api/Common/SubmitContactUs",
  footerHeading: "/api/Common/GetFooterHeading",
  getThingsToDo: "/api/Common/GetThingsToDo",
  getCountryCityPageData: "/api/Common/GetCountryCityPageData",
  bookingsList: "/api/Common/GetBookingsList",
  cityListByCountryId: "/api/Common/GetCityListByCountryId",
  verifyIciciPayment: "/api/Common/VerifyIciciPaymentAsync",
  verifyRazorpayPayment: "/api/Common/VerifyRazorpayPaymentAsync",
  verifyStripePayment: "/api/Common/VerifyStripePaymentAsync",
  downloadInvoice: "/api/Common/DownloadInvoice",
  getBookingDetails: "/api/Common/GetBookingDetails",
  downloadVoucher: "/api/Common/DownloadVoucher",
  saveHomePageEnquiryPopup: "/api/Common/SubmitHomePageEnquiryPopup",
  getEnquiryDestination: "/api/Common/GetEnqueryDestination",
  getEngageList: "/api/Common/GetEngageList",
  randomReviewList: "/api/Common/GetRandomeReviewList",
};
